<div class="flex flex-col flex-auto items-center sm:justify-center min-w-0">
    <div class="w-full sm:w-auto py-8 px-4 sm:p-12 sm:rounded-2xl sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <div class="w-12">
                <img src="/assets/images/logo.svg">
            </div>
            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">Limit Exceeded!</div>
            <div class="mt-0.5">
                <ng-container *ngIf="reason == 'LIMIT_EXCEEDED'">
                    Increase your account limits by upgrading to a higher plan.
                </ng-container>
            </div>
            <div class="mt-8">
                <button
                    (click)="onExtendSubscriptionButtonClick.emit(true)"
                    [@shake]="true"
                    class="fuse-mat-button-large w-full mt-3"
                    mat-flat-button
                    type="button"
                    [color]="'primary'" [routerLink]="'/account/my-account/subscription'">
                   Upgrade Subscription
                </button>
            </div>
        </div>
    </div>
</div>